import React, { useState, useRef } from "react";
import { Navigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getAgencies, deleteAgency } from "../../actions/agency";
import AgencyModal from "./AgencyModal/AgencyModal"
import { clearMessage } from "../../actions/message";
import Filter from "../Filter";
import { toast } from 'react-toastify';
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import ConfirmDialog from "../ConfirmDialog";
import { getUsers } from "../../actions/user";
import { Grid, IconButton, Button } from "@mui/material";
import { DataGrid } from '@mui/x-data-grid';
import { styled } from "@mui/material/styles";
import { DataGridPro, GridActionsCellItem, GridToolbarExport, GridToolbarContainer } from '@mui/x-data-grid-pro';

const AgenciesManagement = (props) => {

    let agenciesLoaded = false;
    const dispatch = useDispatch();

    const searchBarHelper = "Search for an agency..."


    const [agencyToDelete, setAgencyToDelete] = useState(null);

    const [selectedAgency, setSelectedAgency] = useState(null);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [modalShow, setModalShow] = useState(false);
    const [filter, setFilter] = useState('');
    const [activeFilter, setActiveFilter] = useState(true);
    const { message } = useSelector(state => state.message);
    const { user: currentUser } = useSelector((state) => state.auth);
    const { agencies: listAgencies } = useSelector((state) => state.agencies);
    const { users: listUsers } = useSelector((state) => state.users);

    const HandleFilter = (e) => { setFilter(e.toLowerCase()) }

    useEffect(() => {

        if (!listUsers) {
            dispatch(getUsers());
        }

        if (!agenciesLoaded) {
            dispatch(getAgencies()).then(() => {
                agenciesLoaded = true;
            });
        }
    }, []);

    const updateModalShow = (show) => { setModalShow(show) }

    const updateActiveFilter = (e) => {
        setActiveFilter(e.target.checked);
    }

    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <GridToolbarExport
                    printOptions={{ disableToolbarButton: true }}
                    csvOptions={{
                        fileName: 'agencies',
                        delimiter: ';',
                        utf8WithBom: true,
                    }}
                />
            </GridToolbarContainer>
        );
    }

    //On supprime l'agence
    const delete_agency = (agency_id) => {
        if (agency_id > 0) {
            dispatch(deleteAgency(agency_id)).then(() => { })
                .catch(() => {
                    toast.error(`${message}`)
                });
        }
    }

    //On ouvre le modal pour éditer une agence
    const edit_agency = (show, a) => {
        dispatch(clearMessage());
        setSelectedAgency(a);
        updateModalShow(show);
    }

    //On ouvre le modal pour créer une agence
    const add_agency = () => {
        dispatch(clearMessage());
        let agency_tmp = { id: 0 };
        updateModalShow(true);
        setSelectedAgency(agency_tmp);
    }

    //Fonction de tri
    function filterAgencies(agency) {
        if (agency.id > 0) {
            if (!agency.active && activeFilter) {
                return false
            }

            if (currentUser.type != 1 && agency.id != currentUser.idAgency) {
                return false
            }
            return agency.name.toLowerCase().includes(filter) || agency.name.toLowerCase().includes(filter)
        }
    }

    //Click sur une ligne
    const handleRowClick = (params) => {
        if (params.id > 0) {
            edit_agency(true, listAgencies.filter((a) => a.id == params.row.id)[0])
        }
    };

    const columns = [
        { field: 'id', headerName: 'ID', hide: true },
        { field: 'name', flex: 1 },
        {
            field: 'actions',
            type: 'actions',
            sortable: false,
            getActions: (params) => {
                return [
                    <>
                        {currentUser.type == 1 &&
                            <>
                                <IconButton aria-label="delete" onClick={() => {
                                    setAgencyToDelete(params.id);
                                    setConfirmOpen(true);
                                }}>
                                    <DeleteIcon />
                                </IconButton>
                                <ConfirmDialog title="Delete Agency ?" content="Are you sure you want to delete this agency ?" open={confirmOpen}
                                    setOpen={setConfirmOpen}
                                    onConfirm={(result) => {
                                        if (result == true) {
                                            dispatch(delete_agency(agencyToDelete))
                                                .then(() => { })
                                                .catch(() => { toast.error(`${message}`); });
                                        }
                                    }}>
                                </ConfirmDialog>
                            </>
                        }
                    </>
                ]
            }
        }];

    const DataGrid_ = styled(DataGrid)(({ theme }) => ({
        "& .MuiDataGrid-columnHeaders": { display: "none" },
        "& .MuiDataGrid-virtualScroller": { marginTop: "0!important" },
    }));

    return currentUser ? (
        <div className="app-container">
            <h1>Agencies management</h1>
            <Filter
                setSearchQuery={HandleFilter}
                searchQuery={filter}
                helper={searchBarHelper}
                setActive={updateActiveFilter}
                addDataFunction={add_agency}
            />
            <TableContainer component={Paper}>
                {listAgencies ?
                    <div style={{ height: "100%", width: '100%' }}>
                        <DataGrid_
                            autoHeight="true"
                            onRowClick={handleRowClick}
                            rows={listAgencies.filter(filterAgencies)}
                            columns={columns}
                            initialState={{ pinnedColumns: { right: ['actions'] } }}
                            getRowClassName={(params) => {
                                return `row-child-${(listAgencies.filter((a) => a.id == params.row.id)[0].active ? "active" : "inactive")}`
                            }}
                            components={{
                                Toolbar: CustomToolbar,
                            }}
                        />
                    </div> : <></>
                }
            </TableContainer>

            <AgencyModal show={modalShow} current_agency={selectedAgency} onHide={() => updateModalShow(false)} updateSelectedAgency={setSelectedAgency} />
        </div>
    ) : <></>
}

export default AgenciesManagement